import "./home/home.scss";

window.addEventListener("load", () => {
  const loadImage = document.getElementById("js-homepage-hero");
  const dest = loadImage.querySelector(".homepageHero__wrapper"),
    img = new Image();

  img.onload = function () {
    dest.classList.add("homepageHero__wrapper--loaded");
    dest.style.setProperty("--background", "url(" + img.src + ")");
  };
  img.src = new URL("../images/hero.webp", import.meta.url).href;
});

/* init video with intersection observer */
let videoObserver = new IntersectionObserver(
  ([entry]) => {
    // load vimeo api if intersecting or has already been scrolled past
    if (entry.isIntersecting || entry.boundingClientRect.y < 0) {
      import("@vimeo/player").then(({ default: Player }) => {
        //loop through all video containers and init the player
        videos.forEach((video) => {
          //Vimeo init and listeners
          const options = {
            width: video.getBoundingClientRect().width,
            url: video.dataset.videoUrl,
          };
          const player = new Player(video, options);
          player.on("loaded", () => removeVideoLoader(video));
        });
      });
      videoObserver.unobserve(entry.target);
    }
  },
  {
    rootMargin: "0px 0px 200px 0px",
  }
);
const videos = document.querySelectorAll(".videoWrapper");
if (videos.length) {
  videoObserver.observe(videos[0]);
}
const removeVideoLoader = function (container) {
  const loader = container.querySelector(".loader");
  if (loader) loader.remove();
};
